import { Tag } from 'antd';
import { CarOutlined, UserOutlined } from '@ant-design/icons';
import type { CustomerStatus, CustomerType } from '@goelectric/shared-types';
import { CUSTOMER_STATUS_META } from '@goelectric/ui-components';
import { StatusBadgeShell, StatusIcon, useStatusColor } from '@/components/StatusBadgeShell';

/**
 * Tipo de cliente (ADR 0047): `FLOTA` es la Cuenta Maestra corporativa; `CONDUCTOR` es un
 * cliente individual. El texto acompaña al color/icono (nunca solo color, WCAG).
 * `tipoCliente` es requerido en el contrato (`Customer`) desde ADR 0047.
 */
export function CustomerTypeBadge({ tipoCliente }: { tipoCliente: CustomerType }) {
  const isFleet = tipoCliente === 'FLOTA';
  return (
    <Tag
      color={isFleet ? 'blue' : 'default'}
      icon={isFleet ? <CarOutlined /> : <UserOutlined />}
      style={{ marginInlineEnd: 0 }}
    >
      {isFleet ? 'Flota' : 'Conductor'}
    </Tag>
  );
}

/** Estado de la cuenta del cliente: color + icono + texto (WCAG, nunca solo color). */
export function CustomerStatusBadge({
  status,
  forceDark = false,
}: {
  status: CustomerStatus;
  forceDark?: boolean;
}) {
  const meta = CUSTOMER_STATUS_META[status];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}
